export enum SensorDisplayTypeEnum {
	analog = 'analog',
	analogStep = 'analogStep',
	discrete = 'discrete',
	string = 'string',
}
